<template>
<div class="contentGlobal">
    <div class="contLogin">
        <div class="login boxLogin relative">
            <button @click="$router.go(-1)" class="btnBack"><icon name="angle-left"></icon> {{ $t("messages.back") }}</button>
            <b-row  class="content" v-if="disableForm"> 
                {{ message }}
            </b-row>
            <b-row>
                <b-col>
                    <!-- Pool details -->
                    <h4>{{ $t("messages.poolDetails") }} </h4>
                    <form @submit.prevent>
                        
                        <b-row>
                            <!-- ID Node -->
                            <b-col cols="2" class="right"><label class="w100 right">{{ $t("messages.idNode") }}</label></b-col>
                            <b-col cols="6">
                                <b-form-input type="text" v-model="detailPool.id" readonly></b-form-input>
                            </b-col>
                            <!-- Pool active -->
                            <!-- <b-col cols="2" class="right"><label class="w100 right ptop15">{{ $t("messages.poolActive") }}</label></b-col>
                            <b-col cols="2">
                                <md-switch v-model="detailPool.form.active" class="md-primary"></md-switch>
                            </b-col>  -->
                        </b-row>
                        <b-row class="mtop10">
                            <!-- Name -->
                            <b-col cols="2" class="right"><label class="w100 right">{{ $t("messages.login.name") }}</label></b-col>
                            <b-col cols="10"><b-form-input type="text" placeholder="Name" v-model.trim="detailPoolName"></b-form-input></b-col>
                        </b-row>
                        <b-row class="mtop10">
                            <!-- Country -->
                            <b-col cols="2" class="right"><label class="w100 right">{{ $t("messages.login.country") }}</label></b-col>
                            <b-col cols="10">
                                <b-form-select class="form-control"  v-model="detailPool.form.country" :options="countries"/>
                            </b-col>
                        </b-row>
                        <b-row class="mtop10" v-if="userProfile.isSuperAdmin">
                            <b-col cols="2" class="right"><label class="w100 right">Company</label></b-col>
                            <b-col cols="10">
                            <select class="form-control" :required="true" v-model="detailPool.company">
                                <option 
                                    v-for="option in companies" :key="option.code" 
                                    v-bind:value="option.code"
                                    :selected="option.code == detailPool.company"
                                    >{{ option.name }}
                                </option>
                            </select></b-col>
                        </b-row>

                        <b-row class="mtop10" v-if="userProfile.isSuperAdmin">
                            <!-- Users -->
                            <b-col cols="2" class="right">
                                <label class="w100 right ptop15">{{ $t("messages.nav.admin-users") }}</label>
                            </b-col>
                            <b-col cols="10">
                                <div class="w100 chips">
                                    <md-chip class="chips" style="margin:3px" v-for="(item, key) in users" :key="key">
                                        {{ item.email }}
                                      <span @click="navigate(item.id);">
                                        <icon name="user-plus"></icon>
                                    </span>
                                    </md-chip>
                                  
                                </div>
                             </b-col>
                        </b-row>
                        <b-row class="mtop10">
                            <!-- City -->
                            <b-col cols="2" class="right"><label class="w100 right">{{ $t("messages.city") }}</label></b-col>
                            <b-col cols="10">
                            <b-form-input type="text" placeholder="city" v-model.trim="detailPool.form.city"></b-form-input></b-col>
                        </b-row>
                        <b-row class="mtop10">
                            <!-- Street -->
                            <b-col cols="2" class="right"><label class="w100 right">{{ $t("messages.street") }}</label></b-col>
                            <b-col cols="10">
                            <b-form-input type="text" placeholder="street" v-model.trim="detailPool.form.street"></b-form-input></b-col>
                        </b-row>
                         <b-row class="mtop10">
                             <!-- Zip-code -->
                            <b-col cols="2" class="right"><label class="w100 right">{{ $t("messages.zipCode") }}</label></b-col>
                            <b-col cols="10">
                            <b-form-input type="text" placeholder="zipcode" v-model.trim="detailPool.form.zipcode"></b-form-input></b-col>
                        </b-row>
                        <b-row class="mtop10">
                            <!-- Latitude -->
                            <b-col cols="2" class="right"><label class="w100 right">{{ $t("messages.latitude") }}</label></b-col>
                            <b-col cols="10">
                            <b-form-input type="text" placeholder="latitude" v-model.trim="detailPool.form.lat"></b-form-input></b-col>
                        </b-row>
                        <b-row class="mtop10">
                            <!-- Longitude -->
                            <b-col cols="2" class="right"><label class="w100 right">{{ $t("messages.longitude") }}</label></b-col>
                            <b-col cols="10">
                            <b-form-input type="text" placeholder="longitude" v-model.trim="detailPool.form.lng"></b-form-input></b-col>
                        </b-row>
                        <b-row class="mtop10" v-if="this.markers.length > 0">  
                            <b-col cols="2" class="right"><label class="w100 right"></label></b-col>
                            <b-col cols="10">
                                <map-geo :initial-pos="currentLocation" ref="mapDetail"></map-geo>
                            </b-col>
                        </b-row>
                        <button @click="$modal.show('form-map');"> {{ (this.markers.length) > 0 ? $t("messages.updateLocation")  : $t("messages.addLocation") }} <icon name="map-marker-alt"></icon></button>
                        <!-- Save changes -->
                        <button @click="updatePool" class="button mtop20 save" :disabled="disableForm">{{ $t("messages.save") }} <icon name="save"></icon></button>
                    </form>
                </b-col>
            </b-row>
        </div>
    </div>
    <modal name="form-map"
        transition="nice-modal-fade"
        classes= "modal-detail"
        :width = 650
        :height = 500
        :pivot-y="0.5"
        :adaptive="true"
        :reset="true"
        :clickToClose="false">
        <div class="box-modal">
            <div slot="top-right">
                <b-btn @click="$modal.hide('form-map');" class="closePopup"> <icon name="times-circle"></icon> </b-btn>
            </div>
            <map-geo style="height:500px; width:650px" type="geo" v-on:onSaveLocation="onSaveLocation" :initial-pos="markers[0]"></map-geo>
        </div>
    </modal>
</div>

</template>

<script>
import { mapState} from 'vuex'
import {required,email, sameAs,  minLength} from 'vuelidate/lib/validators';
import MapGeo from './Map-geo.vue'
const fb = require('../firebaseConfig.js')

export default {
    name: 'PoolDetail',
    components:{ 
        MapGeo
    },
    data() {
        return {
            markers:[],
            disableForm: false,
            detailPoolName: null,
            detailPool: {
                form:{
                    active: true
                }
            },
            message: '',
            isLoading: true,
            currentLocation: {lat:0, lng:0},
            users:[]
        }
    },
    created () {
        this.$nextTick(() => {
            this.id = this.$route.params.poolId;
            this.isLoading = true
            if(this.userProfile && this.userProfile.pools){
                this.getPoolById(this.$route.params.poolId)
            }
        })
        this.setCountries()
    },
    computed: {
        countriesList: function () {
            var index =  this.languages.map((o) => o.code).indexOf(this.$i18n.locale);
            return this.languages[index].countries;
        },
        ...mapState(['languages', 'companies', 'userProfile'])

    },
    watch: {
        'userProfile' : function(profile, oldValue) {
           if(profile){
                this.getPoolById(this.$route.params.poolId)
           }
        },
        "$i18n.locale": function(oldV, newV) {
            this.setCountries();
        }
    },
    methods: {
        poolName(item){
            if(item.names){
                for (var uid of Object.keys(item.names)) {
                    if(this.userProfile.id == item.names[uid].user){
                        return item.names[uid].name
                    } 
                }
            }
            return item.name; //Default name instead
        },
        savePoolName(){
            var item = this.detailPool.form;
            if(item.names){
                for (var uid of Object.keys(item.names)) {
                    if(this.userProfile.id == item.names[uid].user){
                        item.names[uid].name = this.detailPoolName;
                        return item.names;
                    } 
                }

            }else{
                item.names = [{ 'user': this.userProfile.id, 'name': this.detailPoolName}]
                return item.names;
            }
  
        },
        navigate(_id){
            this.$router.push('/user-detail/'+ _id )
        },
       setCountries(){
          this.countries = this.countriesList
        },
        onSaveLocation(address) {
            Object.assign(this.detailPool.form, address);
            this.updateLocation();

            // this.$refs.mapDetail.setMarker(address);
            this.$modal.hide('form-map');
        },
        
         getPoolById (id) {
            this.loading = true;
            this.$store.dispatch('getPoolById', {
                    'id': this.id
                }).then(response => {
                    if(response){
                        this.detailPool = response
                        this.detailPoolName = this.poolName(response.form) //Mapping pool user name 
                        this.isLoading = true
                        this.getUsers();
                        this.updateLocation();
                    }else{
                        this.disableForm = true
                        // The pool does not exist
                        this.message =  this.$t("messages.poolNotExist")   
                    }
                
                }, error => {
                    this.detailPool = null
                    // Error retrieving data
                    this.message = this.$t("messages.retrieveDataError")
                })
        },
        getUsers() {
            fb.usersCollection.where('pools','array-contains', this.id).onSnapshot(res => {
                res.forEach(doc => {
                    if(doc.exists){
                        this.users.push(doc.data())
                    }
                })}, err => {
                    this.error = true
                })            

        },
        updateLocation() {
            this.markers = []
            let coords = {
                lat: String(this.detailPool.form.lat).replace(/,/g, '.'),
                lng: String(this.detailPool.form.lng).replace(/,/g, '.')
            }
            if(Number(coords.lat) != 0 && Number(coords.lng) !=0){
                this.markers.push({
                    position: coords,
                    clickable: false
                 });
                let arr = [];
                arr.push([coords.lat, coords.lng]);
                this.bounds = L.latLngBounds(arr);
                this.currentLocation = {
                    position: coords,
                    clickable: false
                 };
            }
        },
        updatePool() {
            // Updating pool / Sending data
            this.detailPool.form.names = this.savePoolName();
            this.$snotify.async( this.$t("messages.alertUpdatingPool"), () => new Promise((resolve, reject) => {
                this.$store.dispatch('updatePool', {
                    'id': this.id, 
                    'fields': this.detailPool
                }).then(response => {
                   resolve({
                    //    Pool updated
                        body: this.$t("messages.poolUpdated")+"!",
                        config: {
                            timeout: 1000,
                            closeOnClick: true
                        }
                    })
                    this.updateLocation();
                }, error => {
                    reject({
                        // Error updating pool
                        body: this.$t("messages.poolUpdateError"),
                        config: {
                            timeout: 3000,
                            closeOnClick: true
                        }
                    })
                });
            }))
        },
    }
}
</script>

<style scoped>

.box-modal {
  background: white;
  overflow: hidden;
  width: 650px;
  height: 500px;
  border-radius: 5px;
  color: #8b8c8d;
    z-index: 10000;
}

.error {
    font-size: 12px;
    color: sienna;
}

.modal-detail {
    border-radius: 5px;
    background: #F7F7F7;
    box-shadow: 5px 5px 30px 0px rgba(46,61,73, 0.6);
    z-index: 10000;
}

/* .chips{
  background-color: '0xff0000';
} */

</style>



// WEBPACK FOOTER //
// src/components/Pool-form.vue